import { render, staticRenderFns } from "./UserEditFields.vue?vue&type=template&id=1c71a88b&scoped=true"
import script from "./UserEditFields.vue?vue&type=script&lang=ts"
export * from "./UserEditFields.vue?vue&type=script&lang=ts"
import style0 from "./UserEditFields.vue?vue&type=style&index=0&id=1c71a88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71a88b",
  null
  
)

export default component.exports